import { AbstractControl, ValidationErrors } from '@angular/forms';

export function modelValidator(formGroup: AbstractControl): ValidationErrors {
  if (!formGroup.get('modelId') || !formGroup.get('alternativModel') || !formGroup.get('unknownModel')) {
    return null;
  }

  const modelId = formGroup.get('modelId').value;
  const unknownModel = formGroup.get('unknownModel').value;
  const alternativModel = formGroup.get('alternativModel').value;

  if (!modelId && !alternativModel && unknownModel == false) {
    return { modelId: 'Model skal angbives.' };
  }

  return null;
}
